module.exports = __webpack_public_path__ + "media/images/category/feature/index/logo-index-aoj-028687c3052bfa082666454ce540924e.svg";